module.exports = __webpack_public_path__ + "coding.png?eb07b16402bfbcc55b0520084a9a54be";


//////////////////
// WEBPACK FOOTER
// ./src/images/coding.png
// module id = 408
// module chunks = 0